// 小屏-柜体总体数据
<template>
  <div class="DkbSCabinet">
    <div class="item">
      <div class="one" :style="size1">
        <p class="text">拥有设备数</p>
        <p class="num">{{sData.DeviceTotal}}</p>
      </div>
      <div class="one" :style="size1">
        <p class="text">在线设备数</p>
        <p class="num">{{sData.DeviceOnlineNum}}</p>
      </div>
    </div>
    <div class="item">
      <div class="two online" :style="size2">
        <div class="chart" id="onlineRate"></div>
        <!-- <p class="text">在线率</p>
        <p class="num">{{sData.DeviceOnlineRate}}</p> -->
      </div>
      <div class="two" :style="size2">
        <div class="chart" id="enableRate"></div>
        <!-- <p class="text">设备启用率</p>
        <p class="num">{{sData.DeviceEnableNum}}</p> -->
      </div>
    </div>
  </div>
</template>

<script>
  import { dkbApi } from "../../../../static/js/dkb/dkb.js"
  import { showToast } from "../../../../static/js/utility/utility.js"
  let echarts = require('echarts')
  let vm, Timer

  export default {
    name: 'DkbSCabinet',
    components: {
    },
    props: {
      // 父组件传来的参数
      sData: {
        type: Object,
        default: {}
      }
    },
    computed: {
    },
    data () {
      return {
        isBigSize: false,
        size1: {},
        size2: {},
      }
    },
    created () {
      vm = this
    },
    mounted() {
      // 当前比例大于1920*1080，按高度分割
      let clientRatio = document.body.clientWidth/document.body.clientHeight
      vm.isBigSize = clientRatio > (1920/1080)
      if (vm.isBigSize) {
        let htmlFontSize = vm.$store.state.htmlFontSize
        let Height = document.getElementsByClassName('DkbSCabinet')[0].clientHeight
        let size1 = 0.44 * Height + 'px'
        let size2 = 0.42 * Height + 'px'
        vm.size1  = {width: size1, height: size1, fontSize: '0.3rem'}
        vm.size2  = {width: size2, height: size2}
      }
      vm.$nextTick(()=>{
        vm.drawChart()
      })
      vm.timeRefresh()
    },
    destroyed () {
      clearInterval(Timer)
    },
    methods: {
      // 定时刷新数据
      timeRefresh () {
        Timer = setInterval(()=>{
          vm.GetCabinetInfo()
        }, 1000*5*60)
      },
      // 获取柜体总体数据信息（小屏）
      async GetCabinetInfo () {
        let res = await dkbApi.GetCabinetInfo()
        if (res.ErrCode === 0) {
          vm.sData = res.Result
          vm.$nextTick(()=>{
            vm.drawChart()
          })
        } else {
          showToast(res.meta.ErrMsg)
        }
      },
      // 绘制图表
      drawChart () {
        vm.getChart('onlineRate', vm.sData.DeviceOnlineRate)
        vm.getChart('enableRate',vm.sData.DeviceEnableNum)
      },
      // 加载环形图表
      getChart (id, dVal) {
        let myChart = echarts.init(document.getElementById(id))
        let htmlFontSize = vm.$store.state.htmlFontSize,
            titleText = id === 'onlineRate' ? '在线率' : '设备启用率',
            subtext = dVal+'%',
            subtextFS = vm.isBigSize ? 30 : 40,
            rateColor = id === 'onlineRate' ? '#f39801' : '#98c731'

        let option = {
          grid: {
            // left: 0,
            // right: 0,
            // top: 0,
            // bottom: 0
          },
          title: {
            text: titleText,
            subtext: subtext,
            left: 'center',
            // top: (40/100)*htmlFontSize,
            top: '27%',
            textStyle: {
              color: '#fff',
              fontSize: (15/100)*htmlFontSize,
              fontWeight: 'lighter',
            },
            subtextStyle: {
              color: '#fff',
              fontSize: (subtextFS/100)*htmlFontSize,
              fontWeight: 'lighter',
            },
            itemGap: (10/100)*htmlFontSize //主副标题间距
          },
          series: [
            {
              name:'',
              type:'pie',
              radius: ['75%', '100%'],
              // radius: [(55/100)*htmlFontSize, (73/100)*htmlFontSize],
              clockwise: false,  // 逆时针旋转
              color: [rateColor,'#435e77'],
              labelLine: {
                normal: {
                  show: false
                }
              },
              data:[dVal, 100-dVal]
            }
          ]
        }
        myChart.setOption(option)
      },
      // 屏幕变化图表自适应加载
      resizeGetChart () {
        echarts.init(document.getElementById('onlineRate')).resize()
        echarts.init(document.getElementById('enableRate')).resize()
      }
    },
    watch: {
      // 屏幕变化，图表自适应加载
      '$store.state.isOnresize' (newVal, oldVal) {
        // console.log('屏幕变化', newVal)
        if (newVal !== oldVal) {
          vm.resizeGetChart()
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
.DkbSCabinet {
  width: 100%;
  height: 100%;
  padding: 0.03rem 0.87rem 0.16rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-content: space-between;
  .item {
    display: flex;
    justify-content: space-between;
  }
  .one {
    flex-shrink: 0;
    width: 1.53rem;
    height: 1.53rem;
    background: url(/static/images/dkb/cabinet/num_bg.png) center no-repeat;
    background-size: 100%;
    font-size: 0.5rem;
    display: flex;
    flex-direction: column;;
    align-items: center;
    justify-content: center;
    // @media screen and (max-height: 1080px) {
    //   &{
    //     width: 1.3rem;
    //     height: 1.3rem;
    //   }
    // }
    .text {
      font-size: 0.15rem;
    }
    .num {
    }
  }
  .two {
    flex-shrink: 0;
    width: 1.46rem;
    height: 1.46rem;
    position: relative;
    display: flex;
    flex-direction: column;;
    align-items: center;
    justify-content: center;
    .chart {
      width: inherit;
      height: inherit;
      position: absolute;
      left: 0;
      top: 0;
    }
    .text {
      font-size: 0.15rem;
    }
    .num {
      font-size: 0.4rem;
      font-weight: lighter;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DkbPage/SScreen/Cabinet.vue